// @ts-expect-error React import required to render in Jira SSR
import React from 'react';
// eslint-disable-next-line @atlaskit/design-system/use-spotlight-package
import Spotlight from '@atlaskit/onboarding/spotlight';

import { Stack } from '@atlaskit/primitives/compiled/stack';

import { Text } from '@atlaskit/primitives/compiled/text';

import { useIntl } from 'react-intl';

import messages from '../messages';

import type { SpotlightTourStepProps } from '../types';

import { token } from '@atlaskit/tokens';

import { type JSX } from 'react/jsx-runtime';

export const ParentStep = ({ onDismiss }: SpotlightTourStepProps): JSX.Element => {
	const { formatMessage } = useIntl();

	return (
		<Spotlight
			actions={[
				{
					onClick: onDismiss,
					text: formatMessage(messages.changeboardingOkButton),
				},
			]}
			actionsBeforeElement="2/2"
			dialogPlacement="left top"
			dialogWidth={300}
			heading={formatMessage(messages.changeboardingPageTwoTitle)}
			key="jira-filter-refinement-spotlight-popup-parent"
			target="jira-filter-refinement-spotlight-popup-parent"
			targetRadius={token('radius.medium', '3px')}
		>
			<Stack space="space.150">
				<Text>{formatMessage(messages.changeboardingDescriptionParentHasReplacedEpic)}</Text>
			</Stack>
		</Spotlight>
	);
};
